(function(){
  var LIME = "#ccff33";
  var CDN = "https://cdn.shopify.com/s/files/1/1063/9474/7221/";
  var LEX = "black white grey gray green blue red pink orange yellow purple violet navy cream beige brown khaki light dark silver gold ivory olive teal mint sand storm glacier tide tundra bone flax onyx resin azure marsh dew frost pearl wolf alloy cinder eclipse seedling limelight truffle nebula ghost tin twilight rock brook iceberg nimbus winter kasha graphite ink salmon cyan lime coral aqua crimson volt anthracite mushroom sail smoke smokey oatmeal gypsum summit particle guava sunset seaweed cannon foam hero pulse caldera reverse swoosh barely metallic sky sea espresso safari midnight gobi seashell flint honeydew asphalt pelican dust sienna thistle horizon peony foxglove dijon pebble oyster camellia sunstone aquamarine platinum myrtle squash cascade sailor linen heather stone lilac mauve gardenia lily cobalt tangerine juniper magnet ray verdite apollo flurry".split(" ");
  var REMAP = {"nike-alphafly-3-eliud-kipchoge":"nike-alphafly-3"};
  // Orientation normalization (par coloris) — meme sens dans une meme fiche.
  // ORI_IMG: remplace l'image de la pastille par une AUTRE photo du meme produit (aucun logo inverse).
  var ORI_IMG = {
    "nike-pegasus-premium-forrest-gump":"files/nike-pegasus-premium-forrest-gump-2532184_6542595d-0f6c-414f-9cbe-e782d42844f6.webp",
    "nike-pegasus-premium-summit-white-bright-crimson":"files/nike-pegasus-premium-summit-white-bright-crimson-3668160.png"
  };
  // ORI_FLIP: miroir horizontal — uniquement pour des photos SANS logo visible (invisible).
  var ORI_FLIP = {
    "nike-alphafly-3-prototype-white-orange":1,
    "puma-fast-rb-nitro-elite-black":1,
    "nike-alphafly-3-gridiron-white-pure-platinum":1,
    "nike-pegasus-premium-run":1
  };
  var CSS = [
    ".rp-cl{margin:16px 0 4px;max-width:520px}",
    ".rp-cl .rp-cl-lab{font-size:12px;color:#7c7c7c;font-weight:600;margin-bottom:3px}",
    ".rp-cl .rp-cl-sel{font-size:15px;font-weight:800;color:#111;letter-spacing:-.01em;margin-bottom:12px}",
    ".rp-cl .rp-cl-row{display:flex;gap:8px;overflow-x:auto;padding-bottom:6px;-webkit-overflow-scrolling:touch}",
    ".rp-cl .rp-cl-row::-webkit-scrollbar{display:none}",
    ".rp-cl .rp-cl-sw{flex:0 0 auto;width:44px;height:44px;border-radius:50%;border:1px solid #d5d5d5;display:block;padding:0;text-decoration:none}",
    ".rp-cl .rp-cl-sw .rp-cl-pi{display:block;width:100%;height:100%;border-radius:50%;background:#f4f4f2;background-size:cover;background-position:center;background-repeat:no-repeat}",
    ".rp-cl .rp-cl-sw.rp-on{border:2px solid #111;box-shadow:0 0 0 2px "+LIME+"}"
  ].join("");
  function injectCSS(){
    if(document.getElementById("rp-cl-css")) return;
    var st = document.createElement("style");
    st.id = "rp-cl-css";
    st.textContent = CSS;
    (document.head||document.documentElement).appendChild(st);
  }
  function handle(){ var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? m[1] : ""; }
  function esc(s){ return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
  function nice(h){ return h.split("-").map(function(w){ return w.charAt(0).toUpperCase()+w.slice(1); }).join(" "); }
  function buildGroups(prods){
    function hasColor(p){ return (p.options||[]).some(function(o){ return /couleur|color/i.test(o.name||""); }); }
    var cw = {};
    for(var i=0;i<LEX.length;i++){ cw[LEX[i]] = 1; }
    prods.forEach(function(p){ if(hasColor(p)) (p.options||[]).forEach(function(o){ if(/couleur|color/i.test(o.name||"")) (o.values||[]).forEach(function(v){ String(v).toLowerCase().split(/[^a-z0-9]+/).forEach(function(t){ if(t) cw[t] = 1; }); }); }); });
    var sizeOnly = prods.filter(function(p){ return !hasColor(p); });
    var cnt = {};
    sizeOnly.forEach(function(p){ var s = p.handle.split("-"); for(var n=2;n<s.length;n++){ var pre = s.slice(0,n).join("-"); cnt[pre] = (cnt[pre]||0)+1; } });
    var baseOf = {};
    sizeOnly.forEach(function(p){ var s = p.handle.split("-"); var base = null; for(var n=s.length-1;n>=2;n--){ var pre = s.slice(0,n).join("-"); if(cnt[pre]>=2){ base = pre; break; } } baseOf[p.handle] = base; });
    var bases = {};
    Object.keys(baseOf).forEach(function(h){ if(baseOf[h]) bases[baseOf[h]] = 1; });
    function cgb(b){ if(!b) return b; var s = b.split("-"); while(s.length>2 && cw[s[s.length-1]]){ var par = s.slice(0,-1).join("-"); if(bases[par]) s.pop(); else break; } return s.join("-"); }
    var groups = {};
    sizeOnly.forEach(function(p){
      var b = baseOf[p.handle]; if(!b) return;
      var g = cgb(b); if(REMAP[g]) g = REMAP[g];
      var im = (p.images && p.images[0] && p.images[0].src) || "";
      im = im.split("?")[0];
      if(im.indexOf(CDN)===0) im = im.slice(CDN.length);
      var color = p.title.replace(new RegExp("^"+esc(nice(g)), "i"), "").replace(/^[\s\-–—'"]+/, "").trim();
      (groups[g] = groups[g] || []).push([p.handle, im, color || p.title]);
    });
    var out = {};
    Object.keys(groups).forEach(function(g){ if(groups[g].length>=2) out[g] = groups[g]; });
    return out;
  }
  function getGroups(cb){
    try{ var c = window.sessionStorage.getItem("rp_cg_v2"); if(c){ var pj = JSON.parse(c); if(pj && Object.keys(pj).length){ cb(pj); return; } } }catch(e){}
    if(!window.fetch){ cb({}); return; }
    var all = [], page = 1;
    function step(){
      window.fetch("/products.json?limit=250&page="+page, {credentials:"same-origin"}).then(function(r){ return r.json(); }).then(function(d){
        if(d && d.products && d.products.length){ all = all.concat(d.products); page++; if(page<=5 && d.products.length===250) step(); else done(); }
        else done();
      }).catch(done);
    }
    function done(){
      var g = buildGroups(all);
      try{ if(g && Object.keys(g).length){ window.sessionStorage.setItem("rp_cg_v2", JSON.stringify(g)); } }catch(e){}
      cb(g);
    }
    step();
  }
  function render(groups){
    var h = handle(); if(!h) return;
    if(document.getElementById("rp-colorlinks")) return;
    var members = null;
    for(var g in groups){ for(var i=0;i<groups[g].length;i++){ if(groups[g][i][0]===h){ members = groups[g]; break; } } if(members) break; }
    if(!members || members.length<2) return;
    var anchor = document.querySelector("variant-picker");
    if(!anchor || !anchor.parentNode) return;
    injectCSS();
    var cur = null;
    members.forEach(function(m){ if(m[0]===h) cur = m; });
    var pvm = location.search.match(/[?&]preview_theme_id=(\d+)/);
    var q = pvm ? ("?preview_theme_id="+pvm[1]) : "";
    var box = document.createElement("div");
    box.id = "rp-colorlinks";
    box.className = "rp-cl";
    var html = '<div class="rp-cl-lab">Coloris · '+members.length+' disponibles</div>';
    if(cur && cur[2]) html += '<div class="rp-cl-sel">'+cur[2]+'</div>';
    html += '<div class="rp-cl-row">';
    members.forEach(function(m){
      var on = m[0]===h ? " rp-on" : "";
      var img = ORI_IMG[m[0]] || m[1];
      var flip = ORI_FLIP[m[0]] ? "transform:scaleX(-1);" : "";
      html += '<a class="rp-cl-sw'+on+'" href="/products/'+m[0]+q+'" title="'+String(m[2]).replace(/"/g,"")+'"><span class="rp-cl-pi" style="'+flip+'background-image:url('+CDN+img+')"></span></a>';
    });
    html += '</div>';
    box.innerHTML = html;
    anchor.parentNode.insertBefore(box, anchor);
  }
  function build(){
    if(location.pathname.indexOf("/products/")<0) return;
    if(document.getElementById("rp-colorlinks")) return;
    var vp = document.querySelector("variant-picker");
    if(!vp) return;
    var hasCol = false;
    vp.querySelectorAll(".variant-option legend, .variant-option .form__label").forEach(function(l){ if(/couleur|color/i.test(l.textContent||"")) hasCol = true; });
    if(hasCol) return;
    getGroups(function(groups){ render(groups); });
  }
  function boot(){
    build();
    if(window.MutationObserver){
      var scheduled = false;
      var obs = new MutationObserver(function(){ if(scheduled) return; scheduled = true; window.setTimeout(function(){ scheduled = false; if(!document.getElementById("rp-colorlinks")) build(); }, 200); });
      obs.observe(document.documentElement, {childList:true, subtree:true});
    }
    var n = 0;
    var iv = window.setInterval(function(){ if(!document.getElementById("rp-colorlinks")) build(); n++; if(n>16) window.clearInterval(iv); }, 500);
  }
  if(document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
})();
